export default __webpack_public_path__ + "static/media/Smart-Biology-CELLS-U2-Cover-Image.d1145d0f.jpg";